import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Styled from '../styles/FVContents.styled';
import { IFVPackageUnit } from '../interfaces/FVPackageUnit.interface';
import { IoReturnUpBackOutline } from 'react-icons/io5';
import FormFVContent from '../components/FormFVContent';
import { IFVContents } from '../interfaces/FVContents.interface';
import { ToastError, ToastSuccess } from 'components/Toaster';
import VideoPreviewFerramentaVideo from '../components/VideoPreviewFerramentaVideo';
import { bucketS3, caminhoAnexosFerramentaVideo } from 'constants/EnvironmentData';
import Colors from 'enums/Colors';
import { FaPlay } from 'react-icons/fa';
import Cookies from 'js-cookie';
import { AccessbilityFeatureEnum } from '../helpers/AccessbilityFeatureEnum';
import MenuTypePackages from '../components/MenuTypePackages';
import { useFVContent } from '../hooks/FVContent/useFVContent';
import { formatTitleWithIndex, formatTitleWithIndexSizeFontAll } from '../helpers/FormatTitleStyleHelper';
import { TfiReload } from 'react-icons/tfi';
import { useFVRoles } from '../hooks/FVRoles/useFVRoles';
import { Select } from 'antd';
import { IFVRole } from '../interfaces/FVRole.interface';
import { useFetchFVContainer } from '../hooks/FVContainer/useFetchFVContainer';
import { useFVPackage } from '../hooks/FVPackage/useFVPackage';
import useFetch from 'hooks/useFetch';
import { IFVPackage } from '../interfaces/FVPackage.interface';

const AdminFVContents = () => {
    const historyu = useHistory();

    const [form, setForm] = useState<IFVContents>({
        codigo: -1,
        roleId: null,
        roleIds: [],
        title: '',
        description: '',
        capaBase64: '',
        filePathCapa: '',
        altFilePathCapa: '',
        filePathVideo: '',
        accessibilityFeature: AccessbilityFeatureEnum.LIBRAS,
        accessibilityFeatures: [AccessbilityFeatureEnum.LIBRAS],
        ordem: 0,
    });

    const { idContainer, idPackage, idUnit } = useParams<{ idContainer: string; idPackage: string; idUnit: string }>();
    const [packageUnit, setPackageUnit] = useState<IFVPackageUnit | null>(null);
    const [menuActive, setMenuActive] = useState<string>(() => (Cookies.get('menuTypePackage') || 'libras').toLowerCase());
    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
    const [packageData, setPackageData] = useState<IFVPackage | null>(null);
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [idContentSelecionado, setIdContentSelecionado] = useState<number>(0);
    const [isUploadingVideo, setIsUploadingVideo] = useState<boolean>(false);
    const [roles, setRoles] = useState<IFVRole[]>([]);
    const [roleSelected, setRoleSelected] = useState<number | null>(null);

    const { fetchPackageById } = useFVPackage();

    const { listQuery, createContentMutation, updateContentMutation, deleteContentMutation, addVideoContentMutation, handleRefresh } =
        useFVContent(Number(idUnit));

    const { listQueryRoles } = useFVRoles(Number(idContainer));

    const { useUniqueFerramentaVideo } = useFetchFVContainer();

    const { data: containerData, isLoading } = useUniqueFerramentaVideo(Number(idContainer));

    const getS3Url = () => {
        return bucketS3() + caminhoAnexosFerramentaVideo();
    };

    const getAccessibilityFeatureByMenu = () => {
        if (menuActive === 'audio') return AccessbilityFeatureEnum.AUDIO;
        if (menuActive === 'libras') return AccessbilityFeatureEnum.LIBRAS;
        return AccessbilityFeatureEnum.NORMAL;
    };

    const hasAccessibilityFeature = (content: IFVContents, feature: AccessbilityFeatureEnum) => {
        const accessibilityFeatures = content.accessibilityFeatures ?? (content.accessibilityFeature ? [content.accessibilityFeature] : []);
        return menuActive === 'none' ? accessibilityFeatures.length === 0 : accessibilityFeatures.includes(feature);
    };

    useFetch(async () => {
        if (idPackage) {
            const packageData = await fetchPackageById(Number(idPackage));
            setPackageData(packageData);
        }
    }, [idPackage]);

    const goToPackageUnits = (idPackage: number) => {
        if (packageData?.notUnit) {
            historyu.push(`/admin/ferramenta-video/${idContainer}`);
        } else {
            historyu.push(`/admin/ferramenta-video/${idContainer}/${idPackage}`);
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setForm((prev: any) => ({ ...prev, [name]: value }));
    };

    const onCloseModal = () => {
        setForm({
            codigo: -1,
            title: '',
            description: '',
            roleId: null,
            roleIds: [],
            capaBase64: '',
            filePathCapa: '',
            altFilePathCapa: '',
            filePathVideo: '',
            accessibilityFeature: AccessbilityFeatureEnum.LIBRAS,
            accessibilityFeatures: [AccessbilityFeatureEnum.LIBRAS],
            ordem: 0,
        });
        setModalOpen(false);
    };

    const handleUpdateForm = (content: IFVContents) => {
        setForm({
            ...content,
            roleIds: content.roleIds ?? (content.roleId != null ? [content.roleId] : []),
            accessibilityFeatures: content.accessibilityFeatures ?? (content.accessibilityFeature ? [content.accessibilityFeature] : []),
        });
        setModalOpen(true);
    };

    const handleAddVideoToContent = (idContent: number, file: File) => {
        // Detectar se é áudio ou vídeo
        const isAudio = file.type.startsWith('audio/') || /\.(mp3|wav|m4a|aac|flac|ogg|weba)$/i.test(file.name);
        const mediaType = isAudio ? 'Áudio' : 'Vídeo';

        addVideoContentMutation.mutate(
            { idContent, file },
            {
                onSuccess: () => {
                    ToastSuccess(`${mediaType} enviado com sucesso! Aguarde o processamento.`);
                    setIsUploadingVideo(true);
                    // Refetch dos dados após upload bem-sucedido
                    setTimeout(() => {
                        handleRefresh();
                    }, 5000);
                    setIsUploadingVideo(false);
                },
                onError: () => {
                    setIsUploadingVideo(false);
                },
            }
        );
    };

    const submitForm = (e: React.FormEvent<Element>) => {
        e.preventDefault();
        setLoadingSubmit(true);
        if (form.codigo && form.codigo !== -1) {
            updateContentMutation.mutate(
                {
                    ...form,
                    accessibilityFeatures: containerData?.notAccessibility ? [AccessbilityFeatureEnum.NORMAL] : form.accessibilityFeatures,
                    accessibilityFeature: containerData?.notAccessibility
                        ? AccessbilityFeatureEnum.NORMAL
                        : form.accessibilityFeatures?.[0] ?? form.accessibilityFeature,
                },
                {
                    onSuccess: () => {
                        ToastSuccess('Conteúdo atualizado com sucesso!');
                        setLoadingSubmit(false);
                        onCloseModal();
                    },
                    onError: () => {
                        setLoadingSubmit(false);
                        ToastError('Erro ao atualizar conteúdo. Tente novamente mais tarde.');
                        onCloseModal();
                    },
                }
            );
        } else {
            createContentMutation.mutate(
                {
                    ...form,
                    accessibilityFeatures: containerData?.notAccessibility ? [AccessbilityFeatureEnum.NORMAL] : form.accessibilityFeatures,
                    accessibilityFeature: containerData?.notAccessibility
                        ? AccessbilityFeatureEnum.NORMAL
                        : form.accessibilityFeatures?.[0] ?? form.accessibilityFeature,
                },
                {
                    onSuccess: (_response, payload) => {
                        ToastSuccess('Conteúdo criado com sucesso!');
                        const roleValue = payload?.roleId ?? payload?.roleIds?.[0] ?? null;
                        setRoleSelected(roleValue);
                        setIdContentSelecionado(0);

                        const accessibilityFeature = payload?.accessibilityFeatures?.[0] ?? payload?.accessibilityFeature;
                        if (!containerData?.notAccessibility && accessibilityFeature) {
                            const menuValue =
                                accessibilityFeature === AccessbilityFeatureEnum.AUDIO
                                    ? 'audio'
                                    : accessibilityFeature === AccessbilityFeatureEnum.LIBRAS
                                    ? 'libras'
                                    : 'normal';
                            setMenuActive(menuValue);
                            Cookies.set('menuTypePackage', menuValue);
                        }
                        onCloseModal();
                        setLoadingSubmit(false);
                    },
                    onError: () => {
                        setLoadingSubmit(false);
                        ToastError('Erro ao criar conteúdo. Tente novamente mais tarde.');
                        onCloseModal();
                    },
                }
            );
        }
    };

    const deleteContent = async (idContent: number) => {
        deleteContentMutation.mutate(idContent, {
            onSuccess: () => {
                ToastSuccess('Conteúdo deletado com sucesso!');
            },
        });
    };

    useEffect(() => {
        if (listQuery.data) {
            setPackageUnit(listQuery.data);
            const filtered =
                listQuery.data.contents?.filter(content => {
                    const matchAccessibility = containerData?.notAccessibility
                        ? true
                        : hasAccessibilityFeature(content, getAccessibilityFeatureByMenu());
                    const matchRole =
                        roleSelected === null
                            ? !content.roleIds || content.roleIds.length === 0
                            : content.roleIds?.includes(roleSelected) ?? false;
                    return matchAccessibility && matchRole;
                }) || [];
            // Só atualiza se não houver selecionado ou se o selecionado não existe mais
            if (
                idContentSelecionado === 0 ||
                idContentSelecionado === -1 ||
                !filtered.some(content => content.codigo === idContentSelecionado)
            ) {
                setIdContentSelecionado(filtered.length > 0 ? filtered[0].codigo : 0);
            }
        }
    }, [listQuery.data, menuActive, roleSelected, containerData?.notAccessibility]);

    useEffect(() => {
        if (listQueryRoles.data) {
            setRoles(listQueryRoles.data);
            setRoleSelected(listQueryRoles.data.length > 0 ? listQueryRoles.data[0].id : null);
        }
    }, [listQueryRoles.data]);

    // Ref para input file
    const inputFileRef = React.useRef<HTMLInputElement>(null);

    // Função para abrir o seletor de arquivo
    const handleAddVideoClick = () => {
        if (!idContentSelecionado) {
            ToastError('Selecione ou crie um conteúdo para enviar o arquivo.');
            return;
        }

        if (inputFileRef.current) {
            inputFileRef.current.value = '';
            inputFileRef.current.click();
        }
    };

    // Função para converter vídeo em base64 e logar, com validação de tamanho
    const handleVideoSelected = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            //Mudar para receber no máximo 6GB
            const maxSizeGB = 6;
            const maxSizeBytes = maxSizeGB * 1024 * 1024 * 1024;
            if (file.size > maxSizeBytes) {
                ToastError('O arquivo excede o tamanho máximo permitido de ' + maxSizeGB + 'GB.');
                return;
            }
            setIsUploadingVideo(true); // inicia loader
            // Envia o arquivo diretamente
            handleAddVideoToContent(idContentSelecionado, file);
        }
    };

    const handleSelectContent = (contentId: number) => {
        setIdContentSelecionado(contentId);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <Styled.Container>
            <MenuTypePackages handleUpdateMenu={setMenuActive} hidden={containerData?.notAccessibility ?? false} />
            <FormFVContent
                formVisible={modalOpen}
                handleSubmit={submitForm}
                setForm={setForm}
                setFormVisible={onCloseModal}
                form={form}
                handleChange={handleChange}
                loading={loadingSubmit}
                roles={roles.map(r => ({ id: r.id, name: r.title }))}
                notAccessibility={containerData?.notAccessibility}
            />
            {/* Input file oculto para upload de vídeo e áudio */}
            <input type="file" accept="video/*,audio/*" ref={inputFileRef} style={{ display: 'none' }} onChange={handleVideoSelected} />

            <Styled.Content gap="16px">
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <Styled.Button style={{ width: 'fit-content', padding: '8px 12px' }} onClick={() => goToPackageUnits(Number(idPackage))}>
                        <IoReturnUpBackOutline size={22} /> Voltar
                    </Styled.Button>
                    {listQuery.isLoading && <span style={{ fontSize: '14px', color: '#666' }}>Carregando dados...</span>}
                </div>
                <div>
                    <Styled.DescriptionVideo>Selecione uma regra exclusiva</Styled.DescriptionVideo>
                    <Select
                        style={{ width: '380px' }}
                        placeholder="Regras exclusivas"
                        size="large"
                        value={roleSelected}
                        onChange={v => setRoleSelected(v)}
                        options={[
                            { label: 'Todos conteúdos não vinculados', value: null },
                            ...roles.map((r: any) => ({ label: r.title, value: r.id })),
                        ]}
                    />
                </div>
                <Styled.Title>
                    {' '}
                    <span dangerouslySetInnerHTML={{ __html: formatTitleWithIndexSizeFontAll(packageUnit?.title ?? '', 0) }}></span>
                </Styled.Title>
                {!packageUnit?.contents || (!idContentSelecionado && <Styled.Video.Container>Nenhum vídeo disponível</Styled.Video.Container>)}
                {packageUnit?.contents &&
                    packageUnit.contents.sort((a, b) => a.ordem - b.ordem).findIndex(content => content.codigo === idContentSelecionado) !==
                        -1 &&
                    packageUnit.contents
                        .filter(
                            content =>
                                content.codigo === idContentSelecionado &&
                                (containerData?.notAccessibility ? true : hasAccessibilityFeature(content, getAccessibilityFeatureByMenu()))
                        )
                        .map((content, index) => {
                            if (!content.filePathVideo) {
                                return (
                                    <div key={content.codigo} style={{ position: 'relative' }}>
                                        <Styled.Video.Container img={getS3Url() + content.filePathCapa} />
                                        <span
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '8px',
                                                position: 'absolute',
                                                bottom: '40%',
                                                left: '32%',
                                                fontSize: '28px',
                                                color: Colors.White,
                                                zIndex: 2,
                                            }}
                                        >
                                            Nenhuma mídia disponível
                                            <Styled.Button style={{ width: 'fit-content', padding: '8px 12px' }} onClick={handleAddVideoClick}>
                                                <FaPlay /> Adicionar mídia
                                            </Styled.Button>
                                            <Styled.Button style={{ width: 'fit-content', padding: '8px 12px' }} onClick={handleRefresh}>
                                                <TfiReload size={22} />
                                            </Styled.Button>
                                        </span>
                                        {/* Mostra loader sobre a capa se estiver enviando vídeo ou áudio */}
                                        {isUploadingVideo && (
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    background: 'rgba(0,0,0,0.7)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    zIndex: 3,
                                                }}
                                            >
                                                <span style={{ color: '#fff', fontSize: '22px', fontWeight: 'bold' }}>
                                                    Enviando arquivo, aguarde...
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                );
                            }

                            return (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }} key={content.codigo}>
                                    <VideoPreviewFerramentaVideo
                                        videoUrl={(getS3Url() + content.filePathVideo) as string}
                                        capaUrl={(getS3Url() + content.filePathCapa) as string}
                                        titleVideo={formatTitleWithIndex(content.title as string, index)}
                                        isThumbnail={false}
                                        numberIndex={index}
                                        active={idContentSelecionado === content.codigo}
                                        updateVideo={() => {
                                            handleAddVideoClick();
                                        }}
                                        handleRefresh={() => handleRefresh()}
                                        isAdmin
                                    />
                                    <Styled.TitleVideo
                                        dangerouslySetInnerHTML={{ __html: formatTitleWithIndex(content?.title as string, index) }}
                                    />
                                    <Styled.DescriptionVideo dangerouslySetInnerHTML={{ __html: content?.description as string }} />
                                </div>
                            );
                        })}
            </Styled.Content>
            <Styled.Content gap="16px">
                <Styled.Button style={{ width: 'fit-content', padding: '8px 12px' }} onClick={() => setModalOpen(true)}>
                    Novo conteúdo
                </Styled.Button>
                <div style={{ marginTop: '80px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {packageUnit?.contents &&
                        packageUnit.contents
                            .sort((a, b) => a.ordem - b.ordem)
                            .filter(
                                content =>
                                    (containerData?.notAccessibility
                                        ? true
                                        : hasAccessibilityFeature(content, getAccessibilityFeatureByMenu())) &&
                                    (roleSelected === null
                                        ? !content.roleIds || content.roleIds.length === 0
                                        : content.roleIds?.includes(roleSelected) ?? false)
                            )
                            .map((content, index) => {
                                const contentRoleIds = content.roleIds ?? (content.roleId != null ? [content.roleId] : []);
                                if (roleSelected) {
                                    if (contentRoleIds.includes(roleSelected)) {
                                        return (
                                            <VideoPreviewFerramentaVideo
                                                key={content.codigo}
                                                videoUrl={content.filePathVideo ? ((getS3Url() + content.filePathVideo) as string) : ''}
                                                capaUrl={(getS3Url() + content.filePathCapa) as string}
                                                titleVideo={formatTitleWithIndex(content?.title as string, content.ordem - 1)}
                                                isThumbnail={true}
                                                numberIndex={index}
                                                active={idContentSelecionado === content.codigo}
                                                handleActive={() => handleSelectContent(content.codigo)}
                                                handleDelete={() => deleteContent(content.codigo as number)}
                                                handleEditForm={() => handleUpdateForm(content)}
                                                isAdmin={true}
                                            />
                                        );
                                    }
                                } else if (!content.roleIds || content.roleIds.length === 0) {
                                    return (
                                        <VideoPreviewFerramentaVideo
                                            key={content.codigo}
                                            videoUrl={content.filePathVideo ? ((getS3Url() + content.filePathVideo) as string) : ''}
                                            capaUrl={(getS3Url() + content.filePathCapa) as string}
                                            titleVideo={formatTitleWithIndex(content?.title as string, content.ordem - 1)}
                                            isThumbnail={true}
                                            numberIndex={index}
                                            active={idContentSelecionado === content.codigo}
                                            handleActive={() => handleSelectContent(content.codigo)}
                                            handleDelete={() => deleteContent(content.codigo as number)}
                                            handleEditForm={() => handleUpdateForm(content)}
                                            isAdmin={true}
                                        />
                                    );
                                }
                            })}
                </div>
            </Styled.Content>
        </Styled.Container>
    );
};

export default AdminFVContents;
